<top-bar *ngIf="!isMonthlyView" [field]="field" [isLoadingField]="isLoadingField" [userProfile]="userProfile" [errorField]="errorGetField"></top-bar>

<div class="main-container rr-container-color container-fluid">
  <div class="row" style="padding-bottom: 100px; overflow: hidden">
    <div class="col-12">
      <!--Navigation tab-->
      <!--<app-nav-view-datasheet *ngIf="!isMonthlyView" [activeLink]="'run-tickets'"></app-nav-view-datasheet>-->

      <div class="pl-3 pt-2" *ngIf="!isMonthlyView">
        <div>
          {{entryDate | date: 'longDate'}}
          <app-jump-to-datasheet [fieldID]="fieldID" [datasheetID]="datasheetID" [entryDate]="entryDate"></app-jump-to-datasheet>
        </div>
      </div>

      <div class="form-inline justify-content-between pr-4">
        <div class="pl-2">
          <div class="mt-2 mr-5" *ngIf="isLoadingField; else notLoadingField">
            <app-loading-indicator [small]="true"></app-loading-indicator>
          </div>

          <ng-template #notLoadingField>
            <ng-container *ngIf="!field || errorGetField; else noFieldError">
              <div class="text-danger mt-4">
                <strong>{{errorGetField}}</strong>
              </div>
            </ng-container>
            <ng-template #noFieldError>
              <label class="text-muted">Selected Field</label>
              <p-dropdown class="text-uppercase" [options]="fieldOptions" [(ngModel)]="field" optionLabel="fieldName" filter="true" [resetFilterOnHide]="true" (onChange)="onFieldChange($event)">
              </p-dropdown>
            </ng-template>
          </ng-template>
        </div>

        <div *ngIf="isMonthlyView" [formGroup]="customDates">
          <div class="row d-flex justify-content-end">
            <div class="input-group d-flex justify-content-end">
              <p-calendar formControlName="startDate"
                          [(ngModel)]="formatStartDate"
                          [iconDisplay]="'input'"
                          [showIcon]="true"
                          [maxDate]="today"
                          inputId="icondisplay"></p-calendar>
            </div>

            <div class="input-group d-flex justify-content-end">
              <div class="mt-4">
                <span class="px-4">to</span>
              </div>
              <p-calendar formControlName="endDate"
                          [(ngModel)]="formatEndDate"
                          [iconDisplay]="'input'"
                          [showIcon]="true"
                          [maxDate]="today"
                          inputId="icondisplay"></p-calendar>
            </div>
          </div>
          <div *ngIf="customDates.errors?.invalidDateRange">
            <span class="text-danger mr-3">
              End Date must be after Start Date. Please try again.
            </span>
          </div>
          <div class="row mb-4" *ngIf="!customDates.errors?.invalidDateRange"></div>
        </div>

        <!--<p class="text-muted mt-3 pr-3"><i class="fas fa-search"></i></p>
        <input class="form-control" style="min-width: 25vw; font-size: 0.95em; height: calc(1.5em + .75rem + 5px); " type="text" trim="blur" name="runTicketQuery" [(ngModel)]="filters.runTicketQuery" #searchInput="ngModel" (blur)="updateFilters('query', filters.runTicketQuery)" placeholder="Search by battery, tank, or ticket #">-->
      </div>

      <div class="row px-2">
        <div class="col-12">
          <div *ngIf="errorGetLayout || errorGetRunTickets; else noError">
            <div class="pt-4 text-center text-danger">
              <strong>{{ errorGetLayout }}</strong>
              <strong>{{ errorGetRunTickets }}</strong>
            </div>
          </div>
          <ng-template #noError>
            <div *ngIf="isLoading; else layoutLoaded" class="ignore-hover">
              <app-loading-indicator></app-loading-indicator>
            </div>

            <ng-template #layoutLoaded>
              <div class="row message-container">
                <div class="col-sm-12">
                  <div *ngIf="resultMessage" class="small-alert {{ resultMessageClass }}">
                    {{ resultMessage }}
                  </div>
                  <div *ngIf="errorEditMessage" class="small-alert {{ errorEditClass }}">
                    {{ errorEditMessage }}
                  </div>
                </div>
              </div>

              <div class="action-header d-flex justify-content-between">
                <div>
                  <button class="btn btn-outline-primary" (click)="onAddBtn()">
                    <i class="fas fa-plus"></i> Add Ticket
                  </button>

                  <app-import-tickets [fieldID]="fieldID"></app-import-tickets>

                   <button class="btn btn-outline-danger" *ngIf="selectedRows && selectedRows.length > 0" title="Delete run ticket(s)" (click)="onDeleteBtn()">
                     <i class="fas fa-trash"></i> Delete
                   </button>

                  <button class="btn btn-outline-secondary" *ngIf="selectedRows && selectedRows.length > 0" (click)="onClearSelectionBtn()">Clear Selection</button>
                </div>

                <div class="d-flex flex-column">
                  <div>
                    <span class="font-italic" *ngIf="showRequiredMsg">Make sure to complete all required cells to add a new ticket.</span>
                  </div>
                  <button *ngIf="hasFilters" class="btn btn-link text-right" type="button" (click)="clearFilters()">Clear filters</button>
                </div>
              </div>

              <div class="grid-container">
                <!-- The AG Grid component, with Dimensions, CSS Theme, Row Data, and Column Definition -->
                <ag-grid-angular style="width: 100%; font-size: 12px;"
                                 [class]="themeClass"
                                 [rowData]="receivedRunTickets"
                                 [domLayout]="domLayout"
                                 [columnDefs]="colDefs"
                                 [rowSelection]="'multiple'"
                                 [defaultColDef]="defaultColDef"
                                 [pagination]="true"
                                 [paginationPageSize]="paginationPageSize"
                                 [paginationPageSizeSelector]="paginationPageSizeSelector"
                                 (cellValueChanged)="onCellValueChanged($event)"
                                 (gridReady)="onGridReady($event)"
                                 [pinnedTopRowData]="pinnedTopRowData"
                                 [getRowStyle]="getRowStyle"
                                 (cellEditingStopped)="onCellEditingStopped($event)"
                                 (selectionChanged)="onSelectionChanged($event)"
                                 (cellDoubleClicked)="onCellDoubleClicked($event)"
                                 [grandTotalRow]="'bottom'" />
              </div>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Delete Run Ticket(s)" [modal]="true" [(visible)]="deleteDialogVisible" [style]="{ width: '25rem' }">
  <span class="p-text-secondary block mb-5">This action cannot be undone. Are you sure you want to delete the selected run ticket(s)?</span>
  <div class="d-flex justify-content-end pt-4">
    <button class="btn btn-sm btn-outline-secondary" (click)="deleteDialogVisible = false" type="button">Cancel</button>
    <span class="pr-2"></span>
    <button class="btn btn-sm btn-danger" (click)="onConfirmSelected()" title="Delete Run Ticket(s)" type="button">Delete</button>
  </div>
</p-dialog>
